<lib-bottom-sheet [settings]="offlineModeSheetSettings" [open]="open()" contentBackground="transparent" (closed)="handleSheetClosed()" (dismissed)="handleSheetDismissed()">
  <lib-coming-soon-screen [useDarkMode]="useDarkMode()"></lib-coming-soon-screen>

  <lib-app-button expand="block" fill="outline" (click)="handleAgreeButton()">
    {{ 'general.comingSoon.understood' | transloco }}
  </lib-app-button>
</lib-bottom-sheet>
